import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import { withRouter } from 'react-router-dom';
import Divider from '@material-ui/core/Divider';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TextBox from '../../../components/textbox';
import { doFetch } from '../../../services/fetch/fetch.actions';
import { fetchRole } from '../../../services/politician/profile-service';
import DefaultForm from '../../../components/default-form';
import UserForm from '../../../components/user-form';

class PendingPolitician extends Component {
  componentDidMount() {
    const { me: { fetched, fetching }, dispatch } = this.props;
    if (!fetched && fetching) {
      dispatch(doFetch('ME', fetchRole().then((res) => {
        if (!res.ok) throw res;
        return res.json();
      })));
    }
  }

  render() {
    const {
      me: {
        payload: me, fetched, error, fetching,
      },
      classes,
    } = this.props;
    return (
      <div className={classes.root}>
        <Typography variant="h4" color="primary" gutterBottom>Politikerbasen i Trondheim kommune</Typography>
        <Divider className={classes.divider} />
        <TextBox title="Venter på godkjenning">
          <Typography variant="body1">
            Status: Registreringen din er under behandling
          </Typography>
        </TextBox>
        {fetched && !error && (me.roles.includes('politician') ? (
          <DefaultForm
            initialValues={{
              parti: (me.parties && me.parties.length > 0 && me.parties[0].id) || '',
              fnr: '***********',
              fornavn: me.givenName,
              etternavn: me.familyName,
              adresse: me.streetAddress,
              gender: me.sex === 'm' ? 'Mann' : 'Kvinne',
              postnr: me.zipCode,
              poststed: me.city,
              tlfprivat: me.phone,
              arbeidssted: me.workPlace,
              epost: me.email,
              bankkontonummer: me.bankAccount,
              generalInfo: me.generalInfo,
              // stilling: me.party.role,
            }}
            schema={{}}
            onSubmit={() => {}}
            hideButtons
            disabledFields={{
              fornavn: true,
              etternavn: true,
              adresse: true,
              postnr: true,
              poststed: true,
              fnr: true,
              parti: true,
              gender: true,
              tlfprivat: true,
              arbeidssted: true,
              epost: true,
              bankkontonummer: true,
              generalInfo: true,
              // stilling: true,
            }}
          />
        ) : (
          <UserForm
            key="static-form"
            initialValues={{
              fnr: '***********',
              fornavn: me.name.givenName,
              etternavn: me.name.familyName,
              tlfprivat: me.phone,
              epost: me.email,
            }}
            schema={{}}
            onSubmit={() => {}}
            hideButtons
            disabledFields={{
              fornavn: true,
              etternavn: true,
              fnr: true,
              tlfprivat: true,
              epost: true,
            }}
          />
        ))}
        {fetching && (
          <DefaultForm
            initialValues={{
              parti: '',
              fnr: '',
              fornavn: '',
              etternavn: '',
              adresse: '',
              gender: '',
              postnr: '',
              poststed: '',
              tlfprivat: '',
              arbeidssted: '',
              epost: '',
              bankkontonummer: '',
              generalInfo: '',
              // stilling: '',
            }}
            isLoading
            hideButtons
            disabledFields={{
              fornavn: true,
              etternavn: true,
              adresse: true,
              postnr: true,
              poststed: true,
              fnr: true,
              parti: true,
              gender: true,
              tlfprivat: true,
              arbeidssted: true,
              epost: true,
              bankkontonummer: true,
              generalInfo: true,
              // stilling: true,
            }}
          />
        )}
      </div>
    );
  }
}

const styles = () => ({
  root: {
    maxWidth: '50rem',
    marginBottom: '4rem',
  },
  divider: {
    marginBottom: '1rem',
  },
});

PendingPolitician.propTypes = {
  classes: PropTypes.object.isRequired,
  me: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = ({ me }) => ({ me });

export default connect(mapStateToProps)(withStyles(styles)(withRouter(PendingPolitician)));
